import { Component, OnInit } from '@angular/core';
import { SharedService } from '../common/services/sharedService';

@Component({
  selector: 'app-esign-thankyou',
  templateUrl: './esign-thankyou.component.html',
  styleUrls: ['./esign.component.css','./esign-thankyou.component.css']
})
export class EsignThankyouComponent implements OnInit {
  DocumentList: any;

  constructor(private _sharedService: SharedService,) { 
    
  }

  ngOnInit() {
    const shareData = this._sharedService.getData("eOtpData");
    console.log("share data in otp esign",shareData);
    this.DocumentList = shareData;
  }

  public downloadEsignDocument(doc){
    console.log("doc",doc);
    if(doc.url){
      window.open(doc.url, '_blank');
    }
    
}
}
